import { useRemoteDevices } from '@api/media';
import type { Vehicle } from '@data/fms/vehicle/types';
import { memo, useState } from 'react';
import { useMount } from 'react-use';
import DriveCallNotifier from './DriveCallNotifier';
import type { MediaClient } from '@tier4/webauto-media-client';

type DriveCallReceiverProps = {
  vehicle: Vehicle;
};

const DriveCallReceiver = ({ vehicle }: DriveCallReceiverProps) => {
  const { fetchDevices } = useRemoteDevices();
  const [telephones, setTelephones] = useState<MediaClient.RemoteTelephone[]>(
    [],
  );

  useMount(async () => {
    const devices = await fetchDevices(vehicle.vehicle_id);
    if (devices?.telephones.length) {
      setTelephones(devices.telephones);
    }
  });

  return (
    <>
      {telephones.map((telephone) => (
        <DriveCallNotifier
          key={telephone.id}
          vehicle={vehicle}
          telephone={telephone}
        />
      ))}
    </>
  );
};

export default memo(DriveCallReceiver);
